<template>

  <section class="padded">

    <el-row>
      <h3>Notification e-Mails for <b>this {{this.actionData.actionType}}</b></h3>
    </el-row>

    <el-alert type="info"
      title="Organisation Emails"
      description="The default emails are defined by the system administrator. You can add individual emails here."
      show-icon
      center
      :closable="false" />

    <el-row :gutter="12">
      <table class="el-table">
        <thead>
          <th><center>{{this.actionData.organisation.name}}
            <el-button v-if="isTelco() || isSuper()" type="text" @click="updateEmails('telco', true)">
              <i class="fa fa-sync"></i>
            </el-button>
          </center>
        </th>
        <th>
          <center>{{this.xolasClient().name}}
            <el-button v-if="isTowerCo()" type="text" @click="updateEmails('tower', true)">
              <i class="fa fa-sync"></i>
            </el-button>
          </center>
        </th>
      </thead>

      <!--
      <el-input v-if="isTelco()" v-model="email" type="text" size="small">
      <template slot="prepend"><i class="fa fa-envelope"></i></template>
    </el-input>
    <span v-else>
    <b>{{email}}</b> <a v-if="email" :href="'mailto:' + email"><i class="fa fa-edit-outline"></i></a>
  </span>

-->
  <tbody>
    <tr>
      <td>
        <div v-for="(email, index) in emails.telco">
          <el-col :span="18" :offset="2">
            <a v-if="email" :href="'mailto:' + email.email">
              <i class="fa fa-edit-outline"></i> {{email.email}}
            </a>
          </el-col>
          <el-col :span="4">
            <el-button
            style="color: indianred;"
            @click="deleteEmail(emails.telco, index)"
            type="text" size="mini">
            <i class="fa fa-times-circle"></i>
          </el-button>
        </el-col>
      </div>
    </td>
    <td>
      <div v-for="(email, index) in emails.tower">
        <el-col :span="18" :offset="2">
          <a v-if="email" :href="'mailto:' + email.email">
            <i class="fa fa-edit-outline"></i> {{email.email}}
          </a>
        </el-col>
        <el-col :span="4">
          <el-button v-if="isTowerCo()"
          @click="deleteEmail(emails.tower, index)"
          style="color: indianred;"
          type="text" size="mini">
          <i class="fa fa-times-circle"></i>
        </el-button>
      </el-col>
    </div>
  </td>
  </tr>

  <tr>
    <td>
      <div v-if="isTelco() || isSuper()">
        <el-row>
          <el-col :span="16">
            <el-input type="email" v-model="newTelcoEmail" />
          </el-col>
          <el-col :span="4" :offset="1">
            <el-button type="primary"
            @click="addEmail('telco', newTelcoEmail)"
            :disabled="!newTelcoEmail">
            <i class="fa fa-plus"></i> Add</el-button>
          </el-col>
        </el-row>
      </div>
    </td>
    <td>
      <div v-if="isTowerCo()">
        <el-row>
          <el-col :span="16">
            <el-input type="email" v-model="newEmail" />
          </el-col>
          <el-col :span="4" :offset="1">
          <el-button type="primary"
            @click="addEmail('tower', newEmail)"
            :disabled="!newEmail">
            <i class="fa fa-plus"></i> Add</el-button>
          </el-col>
        </el-row>
      </div>
    </td>
  </tr>

  </tbody>

  <tfoot>
    <td>
      <el-col align="center">
      <el-button v-if="isTelco() || isSuper()"
      type="warning"
      icon="fa fa-envelope"
      @click="sendTest('telco')" :disabled="!isEnabled">Send Test Email</el-button>
    </el-col>
    </td>
    <td>
      <el-col align="center">
        <el-button v-if="isTowerCo()"
          type="warning"
          icon="fa fa-envelope"
          @click="sendTest('tower')" :disabled="!isEnabled">Send Test Email</el-button>

       </el-col>

       <div>
         <span class="text-muted">Configure: </span>
         <check-box v-model="emails.sendMail" :disabled="isTelco() || !isManager()" no-form>
         Send E-mails
       </check-box>
     </div>


  </td>
  </tfoot>

</table>
</el-row>


</section>

</template>


<script>

import RequestMixins from '@/mixins/RequestMixins'

export default {
  mixins: [RequestMixins],

  props: {

    rowData: {
      type: Object,
      required: true
    },

    rtxInfo: {
      type: Object,
      required: true
    }

  },


  methods: {
    sendTest (prop = this.isTelco() ? 'telco' : 'tower') {

      var verify = {
        info: this.rtxInfo.info,
        from: {
          email: this.xolasClient().email,
          name: this.xolasClient().name,
          logo: this.xolasClient().logoPath
        },
        sendTo: []
      }

      var i = 0

      for (i = 0; i < this.emails[prop].length; i++) {
        if (this.emails[prop][i].email) {
          verify.sendTo.push(this.emails[prop][i].email)
        }
      }

      this.send(this, this.getEndpoint('mail/verify'), verify, 'Verification e-Mail', this.sent, this.notSent)
    },


    sent (response) {
      this.$message({message: 'e-mail sent', type: 'success'})
    },


    notSent (response) {
      this.$message({message: 'e-mail failed to send', type: 'error'})
      console.error(response)
    },


    addEmail (prop, email) {
      var cont = {}
      cont.sendUploadAlerts = true
      cont.sendApprovalAlerts = true
      cont.email = email

      this.emails[prop].push(this.clone(cont))
      this.newEmail = null
      this.newTelcoEmail = null

      this.actionData.emails = this.emails
      this.saveRequest(this.actionData)
    },


    deleteEmail (list, index) {
      list.splice(index, 1)

      this.actionData.emails = this.emails
      this.saveRequest(this.actionData)
    },


    updateEmails (type, addMissing = false) {

      this.updateEmailList(this.emails[type],
      (type === 'tower'
      ? this.tower
      : this.telco),
      addMissing)

    },


    updateTowerEmails (data) {
      this.tower = data
//      console.log('tower', this.tower)
    },


    updateTelcoEmails (data) {
      this.telco = data
//      console.log('telco', this.telco)
    }

  },

  computed: {

    isEnabled: function () {
      var enabled = false

      var prop = this.isTelco() ? 'telco' : 'tower'

      for (var i = 0; i < this.emails[prop].length; i++) {
        if (this.emails[prop][i]) {
          enabled = true
          break
        }
      }  // for

      return enabled
    }

  },


  data () {
    return {
      newEmail: null,
      newTelcoEmail: null,
      emails: this.rowData.emails,
      actionData: this.rowData,
      telco: [],
      tower: [],
      siteId: this.rowData ? this.rowData.site_id : null
    }

  },


  created () {
    this.fetchData('/contacts/org/' + this.actionData.organisation_id + '/raw/true', this.updateTelcoEmails, 'Telco Contacts')
    this.fetchData('/contacts/org/' + this.xolasClient().id + '/raw/true', this.updateTowerEmails, 'Tower Contacts')
  },


  beforeDestroy () {

//    if (this.actionData.emails !== this.emails) {
      this.actionData.emails = this.emails
      this.saveRequest(this.actionData)
//    }

  }

}

</script>



// WEBPACK FOOTER //
// EmailSetup.vue?77c9949c